import { createContext } from 'react';

import { AlertOptions, ConfirmOptions, OmitDialogOptionsType, PromptOptions } from './types';

type BasicModalsContextValue = {
  alert: (options: OmitDialogOptionsType<AlertOptions>) => Promise<void>;
  confirm: (options: OmitDialogOptionsType<ConfirmOptions>) => Promise<boolean>;
  prompt: (options: OmitDialogOptionsType<PromptOptions>) => Promise<string>;
};

const notMounted = () => new Error('BasicModalsProvider is not mounted in the tree');

export const BasicModalsContext = createContext<BasicModalsContextValue>({
  alert: () => Promise.reject(notMounted()),
  confirm: () => Promise.reject(notMounted()),
  prompt: () => Promise.reject(notMounted()),
});
